import { connect } from 'react-redux';
import { AppState } from 'pages/app/state';
import { DesktopRow as DR } from './desktop-row';
import { MobileRow as MR } from './mobile-row';
import { RowProps, ConnectedProps } from './props';
import { getOperationItemSelector } from './selectors';
import { languageSelector } from 'pages/settings/selectors';
import { connectionSelector } from 'components/connection-status/selectors';
import { isActiveRow } from 'components/operation-grid/selectors';
import { Guid } from 'types/guid';

const mapStateToProps = (state: AppState, props: RowProps): ConnectedProps => {
  return {
    language: languageSelector(state),
    isOnline: connectionSelector(state),
    operationItem: getOperationItemSelector(state, props),
    isActive: isActiveRow(state, props.clientTransactionId as Guid)
  };
};

export const DesktopRow = connect(mapStateToProps)(DR);
export const MobileRow = connect(mapStateToProps)(MR);


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/row/index.ts